import packageData from '../package.json';
import { sdkVersionCheck } from './utils/versioncheck';

export const { version } = packageData;

sdkVersionCheck(version);
